import { Injectable } from '@angular/core';
import firebase from 'firebase/app';
import { AngularFirestore } from "angularfire2/firestore";

@Injectable()
export class ShippingProvider {

  constructor(
    private afs: AngularFirestore
  ) {
  }

  listShipments(program_id)  {
    return this.afs.collection<any>(`program/${program_id}/shipments`, ref =>
      ref.orderBy("createdAt", "desc")
    );
  }

  addShipment(program_id: string, shipment: any, user: any) {
    const doc_id = this.afs.createId();
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const createdBy = user;
    const updatedAt = createdAt;
    const updatedBy = user;
    shipment = { id: doc_id, createdAt, createdBy, updatedAt, updatedBy, ...shipment };
    
    var batch = this.afs.firestore.batch();
    batch.set(this.afs.collection<any>(`program/${program_id}/shipments`).doc(doc_id).ref, shipment);
    return batch.commit();
  }

  updateShipment(program_id: string, shipment: any, user: any) {
    const updatedAt = firebase.firestore.FieldValue.serverTimestamp();
    const updatedBy = user;
    shipment = { updatedAt, updatedBy, ...shipment };
    
    var batch = this.afs.firestore.batch();
    batch.update(this.afs.collection<any>(`program/${program_id}/shipments`).doc(shipment.id).ref, shipment);
    return batch.commit();
  }

  deleteShipment(program_id: string, dispensing_id: string)  {
    var batch = this.afs.firestore.batch();
    batch.delete(this.afs.collection<any>(`program/${program_id}/shipments`).doc(dispensing_id).ref);
    return batch.commit();
  }


}



// WEBPACK FOOTER //
// ./src/providers/shipping/shipping.ts